import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { getLighterColor, rgbToHex } from 'utils/colors';
import SimpleCarousel from 'components/SimpleCarousel';
import NarrativeCard from 'components/Cards/NarrativeSmallCard';
import ThinkChatCard from 'components/Cards/ThinkSeedSmallCard';
import ElementCard from 'components/Cards/ElementSmallCard';
import SpeedDatingCard from 'components/Cards/SpeedDatingSmallCard';
import {
  NARRATIVE, ELEMENT, SPEED_DATING_MEETING, THEME_TABLE,
} from 'constants/types';
import { removeAccents } from 'utils/string';

function OngoingActivity(props) {
  const {
    getOnGoingActivity, onChangeSlide, search, app,
  } = props;
  const serendipityItems = getOnGoingActivity();
  const defaultPosition = _.findIndex(serendipityItems, item => item.serendipityInfo.enabled);

  const handleChangeSlide = (slide) => {
    if (onChangeSlide) {
      onChangeSlide(slide < defaultPosition ? 'past' : 'ongoing');
    }
  };

  const printCards = () => {
    const validTypes = [NARRATIVE, ELEMENT, SPEED_DATING_MEETING, THEME_TABLE];
    const filteredItems = _.filter(serendipityItems, (item) => {
      let name = '';
      let description = '';

      switch (item.serendipityInfo.type) {
        case NARRATIVE:
          name = item.name;
          description = item.description;
          break;
        case THEME_TABLE:
          name = item.name;
          description = item.description;
          break;
        case ELEMENT:
          name = item.name;
          description = item.description;
          break;
        case SPEED_DATING_MEETING:
          name = 'Speed Dating';
          description = `${item.firstname} ${item.lastname}`;
          break;
        default:
          break;
      }


      name = removeAccents(name.toLowerCase());
      description = removeAccents(description.toLowerCase());
      const s = removeAccents(search.toLowerCase());

      if (s !== '' && name.indexOf(s) === -1 && description.indexOf(s) === -1) {
        return false;
      }

      return _.findIndex(validTypes, type => (type === item.serendipityInfo.type)) >= 0;
    });

    const className = 'ongoing_card';
    return _.map(filteredItems, (item) => {
      switch (item.serendipityInfo.type) {
        case NARRATIVE: {
          const color = rgbToHex(getLighterColor(item.section.color, 15 * item.section.position));
          return (
            <NarrativeCard
              key={item.id}
              data={item}
              color={color}
              classesList={className}
            />
          );
        }
        case THEME_TABLE:
          return (<ThinkChatCard data={{ ...item, chatId: item.chat_id }} key={item.id} classesList={[className]} />);
        case ELEMENT:
          return (<ElementCard data={item} key={item.id} classesList={[className]} />);
        case SPEED_DATING_MEETING:
          return (<SpeedDatingCard data={item} key={item.id} color={app.color1} classesList={[className]} footer />);
        default:
          return <div />;
      }
    });
  };

  if (!serendipityItems.length) {
    return null;
  }

  return (
    <SimpleCarousel classesList='ongoing_card' defaultPosition={defaultPosition} onChangeSlide={handleChangeSlide}>
      {printCards()}
    </SimpleCarousel>
  );
}

OngoingActivity.propTypes = {
  getOnGoingActivity: PropTypes.func.isRequired,
  app: PropTypes.object.isRequired,
  onChangeSlide: PropTypes.func,
  search: PropTypes.string,
};

OngoingActivity.defaultProps = {
  onChangeSlide: null,
  search: '',
};

export default OngoingActivity;



// WEBPACK FOOTER //
// ./src/components/OngoingActivity/components/index.jsx